import { Controller } from "@hotwired/stimulus"

// Response-mode picker + weekly bot schedule.
//
//   <div data-controller="bot-schedule">
//     <input type="radio" name="...[response_mode]" data-action="change->bot-schedule#refresh">
//     <div data-bot-schedule-target="schedule">           ← only shown for "scheduled"
//       <div data-bot-schedule-target="day">
//         <input type="checkbox" data-bot-schedule-target="enabled" data-action="change->bot-schedule#refresh">
//         <select data-bot-schedule-target="time">…</select>
//       </div>
//     </div>
//   </div>
//
// The time selects of a day go grey while that day is unchecked, and
// "copy Monday to every day" fills the week from the first row.
export default class extends Controller {
  static targets = ["schedule", "day", "enabled", "time"]

  connect() {
    this.refresh()
  }

  refresh() {
    const radios = this.element.querySelectorAll('input[type="radio"][name$="[response_mode]"]')
    const mode = [...radios].find((r) => r.checked)
    const scheduled = mode && mode.value === "scheduled"
    this.scheduleTargets.forEach((el) => el.classList.toggle("hidden", !scheduled))

    // Mirror the server-rendered highlight on the card that is picked now.
    radios.forEach((radio) => {
      const card = radio.closest("label")
      if (!card) return
      card.classList.toggle("border-orange-500", radio.checked)
      card.classList.toggle("bg-orange-50", radio.checked)
      card.classList.toggle("border-gray-200", !radio.checked)
    })

    this.dayTargets.forEach((row) => {
      const on = row.querySelector('[data-bot-schedule-target="enabled"]').checked
      // Not `disabled`: the times must still submit so a day keeps its hours
      // while switched off.
      row.querySelectorAll('[data-bot-schedule-target="time"]').forEach((select) => {
        select.classList.toggle("opacity-40", !on)
        select.classList.toggle("pointer-events-none", !on)
        select.tabIndex = on ? 0 : -1
      })
      row.classList.toggle("bg-gray-50", !on)
    })
  }

  copyFirstDay(event) {
    event.preventDefault()
    const [first, ...rest] = this.dayTargets
    if (!first) return
    const source = first.querySelectorAll('[data-bot-schedule-target="time"]')
    const enabled = first.querySelector('[data-bot-schedule-target="enabled"]').checked
    rest.forEach((row) => {
      row.querySelector('[data-bot-schedule-target="enabled"]').checked = enabled
      row.querySelectorAll('[data-bot-schedule-target="time"]').forEach((select, i) => {
        select.value = source[i].value
      })
    })
    this.refresh()
  }
}
